module.exports = __webpack_public_path__ + "static/img/zhunshida.382eddf1.svg";